export default __webpack_public_path__ + "media/images/go_logo_blue-a7ec2a5c.svg";